// extracted by mini-css-extract-plugin
module.exports = {"isicWrapper":"Isic_isicWrapper__3ylox","title":"Isic_title__NPU3o","description":"Isic_description__2Yyxu"};